
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export const FEE_SCHEDULE = {
    MINT: {
        SOL: {
            BASE: 0.1,
            TOKEN_2022_EXTRA: 0.05
        },
        SUI: {
            BASE: 5
        }
    },
    TRADE: {
        MAKER: 0.001, // 0.1%
        TAKER: 0.0025 // 0.25%
    },
    LOCK: {
        SERVICE_FEE_SOL: 0.5,
        SERVICE_FEE_SUI: 10
    }
};
